/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import React from 'react'
import SumerianContainer from './Sumerian'

class ViewerContainer extends React.Component {
  constructor(props) {
    super(props)
    this.frameRef = React.createRef()
  }

  setupListeners = () => {
    window.addEventListener('message', ({ data }) => {
      if (!data || !data.name) return
      console.log('ViewerContainer heard: ', data)

      if (data.name === 'readyForData') {
        this.sendMessage('dataDump', {
          locations: this.props.sumerianData,
          currentConfig: this.props.currentConfig,
          currentLocation: this.props.currentLocation,
          currentSeason: this.props.currentSeason,
          sumerian: this.props.sumerian,
        })
      } else if (data.name === 'selectLocation') {
        this.props.setters.setLocation(data.currentLocation)
      }
    })
  }

  changeSelectedLocation(next, orig) {
    if (next.currentLocation === orig.currentLocation) return

    this.sendMessage('changeLocation', {
      currentLocation: next.currentLocation,
    })
  }

  changeRatingData(next, orig) {
    if (
      next.currentConfig === orig.currentConfig &&
      next.currentSeason === orig.currentSeason
    ) {
      return
    }
    this.sendMessage('changeRatings', {
      currentConfig: next.currentConfig,
      currentSeason: next.currentSeason,
    })
  }

  sendMessage(name, data) {
    this.frameRef.current.contentWindow.postMessage(
      {
        name,
        ...data,
      },
      '*'
    )
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.changeSelectedLocation(nextProps, this.props)
    this.changeRatingData(nextProps, this.props)
    return false
  }

  render() {
    const { className, Display, sumerianUrl } = this.props
    return (
      <Display
        className={className}
        frameRef={this.frameRef}
        setHandler={this.setupListeners}
        sumerianUrl={sumerianUrl}
      />
    )
  }
}

export default ViewerContainer
